import { IconArrowRight, IconLoader2 } from "@tabler/icons-react"
import { type ComponentType, type FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Props = {
	title: string
	description?: string
	icon: ComponentType<{ className?: string }>
	accent: string
	onClick(): void
	isLoading?: boolean
	isDisabled?: boolean
}
const ChoiceCard: FC<Props> = ({ title, description, icon: Icon, accent, onClick, isLoading, isDisabled }) => (
	<button
		type="button"
		onClick={onClick}
		disabled={isDisabled || isLoading}
		className="group focus-visible:outline-primary flex w-full cursor-pointer items-center gap-4 rounded-2xl border border-slate-200 bg-[#fcfcfb] p-4 text-left transition-all duration-200 hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-[0_12px_28px_rgba(15,23,42,0.09)] focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-60"
	>
		<div className={cn("flex size-11 shrink-0 items-center justify-center rounded-xl", accent)}>
			<Icon className="size-5" />
		</div>
		<div className="min-w-0 flex-1">
			<h2 className="text-base font-bold text-slate-900">{title}</h2>
			{description !== undefined && <p className="mt-0.5 text-sm font-medium text-slate-600">{description}</p>}
		</div>
		{isLoading ? (
			<IconLoader2 className="text-primary size-5 shrink-0 animate-spin" />
		) : (
			<IconArrowRight className="group-hover:text-primary size-5 shrink-0 text-slate-300 transition-transform duration-200 group-hover:translate-x-1" />
		)}
	</button>
)

export default ChoiceCard
